import { createStyles, Fab, Grid, makeStyles, Typography } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import React from 'react';
import BackPage from '../../components/BackPage/BackPage.component';
import BarInfo from '../../components/BarInfo/BarInfo.component';
import BarPOCInfo from '../../components/BarPOCInfo/BarPOCInfo.component';
import BarReports from '../../components/BarReports/BarReports.component';
import PageContainer from '../../components/PageContainer/PageContainer.component';
import { IBar } from '../../models/IBars';
import { IReport } from '../../models/IReport';

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            flex: 1,
        },
        heading: {
            color: '#fff',
            marginBottom: theme.spacing(2),
        },
        editFab: {
            backgroundColor: '#fff',
            color: '#000'
        },
        deleteFab: {
            backgroundColor: '#fff',
            color: 'red',
            marginLeft: theme.spacing(2)
        },
        img: {
            margin: "auto",
            display: "block",
            maxWidth: "300px",
            marginBottom: "1em",
            [theme.breakpoints.up("md")]: {
                maxWidth: "400px",
            }
        }
    })
);

interface Props {
    entry: IBar,
    reports: IReport
    onEditClick: () => void
    onDeleteClick: () => void
}

export default function BarDetailsPage({
    reports,
    entry,
    onEditClick,
    onDeleteClick
}: Props) {
    const classes = useStyles();

    return (
        <BackPage>
            <PageContainer>
                <Grid container direction="column">
                    <Grid item>
                        <Grid className={classes.heading} container direction="row">
                            <Grid xs item>
                                <Typography variant="h5">
                                    Bar Details
                            </Typography>
                            </Grid>
                            <Grid item direction="row" justify="center" alignItems="center">
                                <Fab className={classes.editFab} size="medium" aria-label="edit" onClick={onEditClick}>
                                    <EditIcon />
                                </Fab>
                                <Fab className={classes.deleteFab} size="medium" aria-label="delete" onClick={onDeleteClick}>
                                    <DeleteIcon />
                                </Fab>
                            </Grid>
                        </Grid>
                        <BarInfo
                            data={entry}
                        />
                    </Grid>


                    <Grid item>
                        <Grid className={classes.heading} container direction="column">
                            <Grid xs item>
                                <Typography variant="h5">
                                    Image
                            </Typography>
                            </Grid>

                        </Grid>
                        <img
                            className={classes.img}
                            src={entry?.image?.url}
                            alt={`${entry?.name || "Bar"} image`}
                        />
                    </Grid>

                    <Grid item>
                        <Typography className={classes.heading} variant="h5">
                            Point of Contact Details
                    </Typography>
                        <BarPOCInfo
                            data={entry?.poc}
                        />
                    </Grid>
                    <Grid item>
                        <Typography className={classes.heading} variant="h5">
                            Reports
                    </Typography>
                        <BarReports
                            data={reports}
                        />
                    </Grid>
                </Grid>
            </PageContainer>
        </BackPage>
    )
}
